// 注意：不同 action Object 组的 key 可以重复，但是 value 不能重复

// 用户
const userAction = {
  login: 'login',
  logout: 'logout'
}

export {
  userAction
}



// WEBPACK FOOTER //
// ./src/store/action-names.js